import { render, staticRenderFns } from "./SimulasiPembayaran.vue?vue&type=template&id=1b0fc92e&"
import script from "./SimulasiPembayaran.vue?vue&type=script&lang=js&"
export * from "./SimulasiPembayaran.vue?vue&type=script&lang=js&"
import style0 from "./SimulasiPembayaran.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports